<template>
  <div class="quick-range-buttons">
    <span class="quick-range-label">{{ $t('components.quickRange.label') }}</span>
    <button
      v-for="preset in presets"
      :key="preset.key"
      type="button"
      class="btn btn-sm"
      :class="{ active: activePreset === preset.key }"
      @click="applyPreset(preset.key)"
    >
      {{ $t(preset.label) }}
    </button>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import dayjs from 'dayjs'

const RANGE_PRESETS = [
  { key: 'today', label: 'components.quickRange.today' },
  { key: 'yesterday', label: 'components.quickRange.yesterday' },
  { key: 'last24h', label: 'components.quickRange.last24h' },
  { key: 'last7days', label: 'components.quickRange.last7days' }
] as const

type RangePresetKey = typeof RANGE_PRESETS[number]['key']

export default defineComponent({
  name: 'QuickRangeButtons',
  emits: ['rangeSelected'],
  data(): {
    presets: typeof RANGE_PRESETS,
    activePreset: RangePresetKey | null
  } {
    return {
      presets: RANGE_PRESETS,
      activePreset: null
    }
  },
  methods: {
    applyPreset(key: RangePresetKey): void {
      this.activePreset = key
      let start = dayjs()
      let end = dayjs()

      switch (key) {
        case 'today':
          start = dayjs().startOf('day')
          end = dayjs().endOf('day')
          break
        case 'yesterday':
          start = dayjs().subtract(1, 'day').startOf('day')
          end = dayjs().subtract(1, 'day').endOf('day')
          break
        case 'last24h':
          start = dayjs().subtract(24, 'hours')
          end = dayjs()
          break
        case 'last7days':
          start = dayjs().subtract(6, 'day').startOf('day')
          end = dayjs().endOf('day')
          break
      }

      this.$emit('rangeSelected', {
        start: start.format('YYYY-MM-DD HH:mm'),
        end: end.format('YYYY-MM-DD HH:mm')
      })
    }
  }
})
</script>

<style lang="scss" scoped src="@/assets/scss/quick-range-buttons.scss"></style>
